import { getToken } from '@loadsmart/miranda-tokens';

import type { GridProps } from './grid.types';

export const defaultGridProps: Required<
	Omit<GridProps, 'rowGap' | 'columnGap'>
> = {
	gap: 'spacing-4',
	minColumnWidth: getToken('spacing-30') as string,
};
